<template>
  <v-card class="elevation-0">
    <v-card-text class="pa-5">
      <div class="text-caption text-uppercase font-weight-bold grey--text mb-4">Printer</div>
      <div class="d-flex align-center mb-4">
        <div :class="['status-dot', online ? 'status-online' : 'status-offline']"></div>
        <div class="ml-3">
          <div class="text-body-2 font-weight-medium">{{ statusText }}</div>
          <div class="text-caption grey--text">localhost:8081</div>
        </div>
      </div>
      <v-btn
        small
        outlined
        rounded
        block
        @click="checkHealth"
        :loading="checking"
        class="text-none"
      >
        <v-icon left small>mdi-refresh</v-icon>
        Refresh
      </v-btn>

      <div class="text-caption text-uppercase font-weight-bold grey--text mt-6 mb-3">Download Printer API</div>
      <div class="d-flex" style="gap: 8px">
        <v-btn
          small
          outlined
          rounded
          class="text-none flex-grow-1"
          :href="apiUrl + '/api/labelbase/label/printer-download/linux'"
        >
          <v-icon left small>mdi-linux</v-icon>
          Linux
        </v-btn>
        <v-btn
          small
          outlined
          rounded
          class="text-none flex-grow-1"
          :href="apiUrl + '/api/labelbase/label/printer-download/windows'"
        >
          <v-icon left small>mdi-microsoft-windows</v-icon>
          Windows
        </v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'PrintPanel',
  data: function () {
    return {
      online: false,
      simulate: false,
      checking: false,
      apiUrl: process.env.VUE_APP_API_URL || 'http://localhost:8001',
    };
  },
  computed: {
    statusText: function () {
      if (!this.online) return 'Printer Offline';
      return this.simulate ? 'Simulator Mode' : 'Printer Online';
    },
  },
  mounted: function () {
    this.checkHealth();
  },
  methods: {
    checkHealth: function () {
      var self = this;
      self.checking = true;
      fetch('http://localhost:8081/health', { method: 'GET' })
        .then(function (resp) {
          if (resp.ok) return resp.json();
          throw new Error('not ok');
        })
        .then(function (data) {
          self.online = true;
          self.simulate = data.simulate || false;
        })
        .catch(function () {
          self.online = false;
        })
        .finally(function () {
          self.checking = false;
          self.$emit('status-change', self.online);
        });
    },
  },
};
</script>

<style scoped>
.status-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.status-online {
  background: #34D399;
  box-shadow: 0 0 8px rgba(52, 211, 153, 0.6);
}
.status-offline {
  background: #EF4444;
  box-shadow: 0 0 8px rgba(239, 68, 68, 0.4);
}
</style>
